var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"today-alarm dn-content-bg"},[_c('div',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.resize),expression:"resize"}],ref:"lineBoxTwo",staticClass:"lineBox",attrs:{"id":_vm.echartsId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }